import { render } from "./ReceiptTroubleshooting.vue?vue&type=template&id=64d4bba8"
import script from "./ReceiptTroubleshooting.vue?vue&type=script&lang=js"
export * from "./ReceiptTroubleshooting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__